export default "__VITE_ASSET__BEYOXWNQ__"